import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import './ChatLink.scss';

function ChatLink({ children, className, disabled, external, href, to, onClick, ...rest }) {
  const linkClasses = classNames(
    'chat-link',
    {
      'chat-link--disabled': disabled,
    },
    className
  );

  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    if (onClick) {
      onClick(e);
    }
  };

  // For external links or when href is provided
  if (external || href) {
    return (
      <a
        href={disabled ? undefined : href}
        className={linkClasses}
        onClick={handleClick}
        target={external ? '_blank' : undefined}
        rel={external ? 'noopener noreferrer' : undefined}
        aria-disabled={disabled}
        {...rest}
      >
        {children}
      </a>
    );
  }

  // For internal routing with React Router
  if (to) {
    if (disabled) {
      return (
        <span className={linkClasses} aria-disabled={disabled} {...rest}>
          {children}
        </span>
      );
    }

    return (
      <Link
        to={to}
        className={linkClasses}
        onClick={handleClick}
        {...rest}
      >
        {children}
      </Link>
    );
  }

  // Fallback for cases where neither href nor to is provided
  return (
    <span className={linkClasses} aria-disabled={disabled} {...rest}>
      {children}
    </span>
  );
}

ChatLink.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  external: PropTypes.bool,
  href: PropTypes.string,
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object, // For React Router location objects
  ]),
  onClick: PropTypes.func,
};

ChatLink.defaultProps = {
  className: '',
  disabled: false,
  external: false,
  href: undefined,
  to: undefined,
  onClick: undefined,
};

export default ChatLink;